import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'dK9J}[~Bc4MSN%((!3-^n20&vkpy^g833aQ%gR[!,=>sFx[5<D%C+~"<NW%JBmX';

const encrypt = text => {
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

const decrypt = cipher => {
  const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

const setTransform = createTransform(
  // in-bound (save to storage)
  (inboundState, key) => {
    return encrypt(JSON.stringify(inboundState));
  },
  // out-bound (load from storage)
  (outboundState, key) => {
    return JSON.parse(decrypt(outboundState));
  }
);

export default setTransform;